import camelize from 'camelize';

import {
  IAiCharacterInformation,
  ICharacterCreateForm,
  ICharacterTag,
  IChatCharacter,
  IChatPagination,
  IChatResponse,
  IFreeCharacter,
  IKeyPagination,
  IRelatedTag,
  IVisualCandidateGroups,
} from '@model';
import { toQueryString } from '@utils/misc';

import { CHAT_BOT_API } from './chatbot';

export const postCharacter = async (payload: ICharacterCreateForm) => {
  const { data } = await CHAT_BOT_API.post<IChatResponse<ICharacterCreateForm>>(
    `playset/`,
    payload
  );
  return data.result;
};

export const getTempCharacter = async (id: number) => {
  const { data } = await CHAT_BOT_API.get<IChatResponse<ICharacterCreateForm>>(
    `playset/${id}/`
  );
  return data.result;
};

export const patchCharacter = async (
  payload: ICharacterCreateForm,
  id: number
) => {
  const { data } = await CHAT_BOT_API.patch<
    IChatResponse<ICharacterCreateForm>
  >(`playset/${id}/`, payload);
  return data.result;
};

export const releaseCharacter = async (id: number) => {
  const { data } = await CHAT_BOT_API.patch<
    IChatResponse<ICharacterCreateForm>
  >(`playset/${id}/release/`);

  return data.result;
};

export const getAiCharacterSet = async (id: number | undefined) => {
  const { data } = await CHAT_BOT_API.get<
    IChatResponse<IAiCharacterInformation>
  >(`playset/${id}/ai-writing/`);

  return data.result;
};

export type CharacterTagQueries = {
  name?: string;
  order_by?: 'tagged_character_count' | 'id';
  sort?: 'asc' | 'desc';
};

export const getCharacterTags = async (
  query?: CharacterTagQueries,
  withProtected = true,
  lastEvaluatedKey = ''
) => {
  const { data } = await CHAT_BOT_API.get<
    IChatResponse<IKeyPagination<ICharacterTag>>
  >(
    `character-tags/${toQueryString({
      ...query,
      lastEvaluatedKey,
      p: withProtected,
    })}`
  );
  return data?.result;
};

export const getCharacterRecommendTags = async () => {
  const { data } = await CHAT_BOT_API.get<IChatResponse<ICharacterTag[]>>(
    'character-tags/recommendations/'
  );

  return data?.result;
};
export type CharacterListQuery = {
  only_like?: 'only_like';
  order_by?:
    | 'id'
    | 'stat__message_count'
    | 'stat_like_count'
    | 'like_at'
    | 'updated_at'
    | 'created_at'
    | 'released_at';
  status?: 'PUB' | 'PRV' | 'DRF';
  story_id?: string;
  tag_ids?: number[];
  user_id?: string;
};

export const getCharacterList = async (
  query: CharacterListQuery,
  page = 1,
  perPage = 20
) => {
  const { data } = await CHAT_BOT_API.get<
    IChatResponse<IChatPagination<IChatCharacter>>
  >(`/characters/${toQueryString({ ...query, page, perPage })}`);
  return data.result;
};

export type RelatedCharacterTagsQuery = {
  name?: string;
  order_by?: 'tagged_character_count' | 'id';
  sort?: 'asc' | 'desc';
  tag_ids?: string[] | number[];
};

export const getRelatedTags = async (tagId: number | string) => {
  const { data } = await CHAT_BOT_API.get<IChatResponse<IRelatedTag[]>>(
    `/character-tags/${tagId}/related-tags/`
  );

  return data?.result;
};

export const getFreeCharacters = async () => {
  const { data } = await CHAT_BOT_API.get<IChatResponse<IFreeCharacter[]>>(
    `/character-free-information/`
  );
  return camelize(data?.result) as IFreeCharacter[];
};

export const postCreateVisualCandidateGroups = async (id: number) => {
  const { data } = await CHAT_BOT_API.post<
    IChatResponse<IVisualCandidateGroups>
  >(`/playset/${id}/visual-candidate-group/`);
  return camelize(data?.result) as IVisualCandidateGroups;
};
